import { render } from "./ForecastDataLineage.vue?vue&type=template&id=5144b91c"
import script from "./ForecastDataLineage.vue?vue&type=script&lang=js"
export * from "./ForecastDataLineage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__